import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import _ from 'lodash';
import { Helper } from 'src/app/shared/utils/helper';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressBookService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  listAddressBook(paramsFilter) {
    const params = this.getParams(paramsFilter);
    return this.http.get(`${this.baseUrl}/addressbook/list`, { params: params });
  }
  private getParams(prm): HttpParams {
    const { Page, Sort, SortDirection, Query } = prm;;
    let params = new HttpParams().set("Page", Page).set("Query", Query);
    if (!Helper.isEmpty(Sort) && !Helper.isEmpty(SortDirection)) {
      params = params.set("Sort", Sort).set("SortDirection", SortDirection);
    }
    return params;
  }

  getAddressBook(id): Observable<any> {
    return this.http.get(`${this.baseUrl}/addressbook/view/${id}`);
  }

  postAddressBook(data):Observable<any>{
    return this.http.post(`${this.baseUrl}/addressbook/create`,data);
  }

  importBulkAddressBook(data) {
    return this.http.post(`${this.baseUrl}/addressbook/upload`, data);
  }

  putAddressBook(data):Observable<any>{
    return this.http.put(`${this.baseUrl}/addressbook/edit`,data);
  }

  deteteAddressBook(id){
    return this.http.delete(`${this.baseUrl}/addressbook/delete/${id}`);
  }
}
